import type { Practitioner, Reference } from '@medplum/fhirtypes'
import { ExtendedPractitioner } from '@seen/core/models/practitioner'
import type { JSX } from 'react'
import { useRead } from '#src/hooks/useRead.ts'
import { useReference } from '#src/hooks/useReference.ts'

export function PractitionerName({
  practitioner,
}: {
  practitioner: Reference<Practitioner> | string
}): JSX.Element {
  const practitionerReference = useReference(practitioner)
  const { data: instance } = useRead(
    ExtendedPractitioner,
    practitionerReference
  )
  return (
    <>
      {instance?.name}
      {instance?.roles && (
        <span className="ml-1 text-foreground-secondary">
          {instance.roles.join(', ')}
        </span>
      )}
    </>
  )
}
